import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@this/src/components/shared/ui/data_displays/table';
import type HotelOrderItemEanTotal from '@this/src/domain/arrangement/hotel_order_item_ean_total';
import type Arranger from '@this/src/domain/arranger/arranger';
import TotalTableRow from './total_table_row';

interface Props {
  hotelOrderItemEanTotals: HotelOrderItemEanTotal[];
  arrangers: Arranger[];
  currentArranger: Arranger | null;
  suppliedItemId: number | null;
}

const TotalResultTable: React.FC<Props> = ({
  hotelOrderItemEanTotals,
  arrangers,
  currentArranger,
  suppliedItemId
}) => {
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>予約日</TableCell>
          <TableCell align="right">HotelElement件数</TableCell>
          <TableCell align="right">卸値の件数</TableCell>
          <TableCell align="right">EAN CSVの件数</TableCell>
          <TableCell align="right">代金詳細の合計金額</TableCell>
          <TableCell align="right">卸値の合計金額</TableCell>
          <TableCell align="right">EAN CSVの合計金額</TableCell>
          <TableCell>完全一致</TableCell>
          <TableCell />
          <TableCell />
          <TableCell>総数確認日</TableCell>
          <TableCell>確認者</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {hotelOrderItemEanTotals.map(hotelOrderItemEanTotal => (
          <TotalTableRow
            key={hotelOrderItemEanTotal.reservationDate.format('YYYY-MM-DD')}
            hotelOrderItemEanTotal={hotelOrderItemEanTotal}
            arrangers={arrangers}
            currentArranger={currentArranger}
            suppliedItemId={suppliedItemId}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default TotalResultTable;
